import { Outlet } from 'react-router';

/**
 * Root layout for every route in the SPA. Route content renders via
 * <Outlet />; the authenticated user menu lives in SplitLayout (it is
 * part of the in-session workspace, not global chrome).
 */
export function RootLayout() {
  return <Outlet />;
}
